import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 5000 },
    debounceTime: { type: Number, default: 1000 }
  }

  initialize () {
    this.refresh = this.debounce(this.refresh.bind(this), this.debounceTimeValue)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  connect () {
    this.startRefreshing()
    this.bindFormSubmitListener()
  }

  disconnect () {
    this.cleanup()
  }

  cleanup () {
    this.stopRefreshing()
    this.unbindFormSubmitListener()
  }

  startRefreshing () {
    if (this.timer) return

    this.timer = setInterval(() => {
      this.refresh()
    }, this.intervalValue)
  }

  stopRefreshing () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  async refresh () {
    if (!this.urlValue) return

    try {
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 5000)

      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html'
        },
        credentials: 'same-origin',
        signal: controller.signal
      })

      clearTimeout(timeoutId)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      if (html.trim()) {
        // eslint-disable-next-line no-undef
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.warn('Reflection refresh request timed out')
      } else {
        console.error('Reflection refresh failed:', error)
      }
    }
  }

  bindFormSubmitListener () {
    this.formElement = this.element.querySelector('form')
    if (this.formElement) {
      this.formElement.addEventListener('submit', this.handleFormSubmit)
    }
  }

  unbindFormSubmitListener () {
    if (this.formElement) {
      this.formElement.removeEventListener('submit', this.handleFormSubmit)
      this.formElement = null
    }
  }

  handleFormSubmit () {
    this.stopRefreshing()
  }

  debounce (func, wait) {
    let timeout
    return function executedFunction (...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}
